<template>
  <nav
    id="mainNav"
    class="navbar navbar-main navbar-expand-lg sticky-top navbar-light bg-light"
  >
    <div class="container">
      <button
        v-if="shouldShowBack"
        type="button"
        class="close"
        aria-label="Back"
        @click="back()"
      >
        <i class="fa fa-chevron-left"/>
      </button>

      <router-link
        class="navbar-brand header-logo-wrapper"
        :to="{name: 'home'}"
      >
        <img
          id="header-logo"
          width="auto"
          height="auto"
          src="/img/logo/fff_header_logo.png"
          alt="Food Fitness First, Inc.®"
        >
      </router-link>

      <component
        :is="isCordova ? 'CordovaAppMenu' : 'AppMenu'"
      ></component>
    </div>
    <div
      id="mainColorBar"
      class="color-bar d-flex flex-row flex-nowrap"
    >
      <div class="bg-green flex-grow-1" />
      <div class="bg-yellow flex-grow-1" />
      <div class="bg-red flex-grow-1" />
    </div>
  </nav>
</template>

<script>

import {mapGetters} from 'vuex';
import AppMenu from "./AppMenu.vue";
import CordovaAppMenu from "./CordovaAppMenu.vue";

export default {
  components: {
    AppMenu,
    CordovaAppMenu,
  },
  computed: {
    ...mapGetters('user', [
      'user',
      'authenticated'
    ]),
    isCordova() {
      return window.IS_CORDOVA;
    },
    shouldShowBack() {
      return this.isCordova && this.$route.path !== '/login';
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('user/logout').then(() => {
        this.$router.push('/login');
        this.$store.dispatch('notifications/setSuccess', 'You have been logged out.');
      });
    },
    back() {
      this.$router.back();
    },
  }
}
</script>

<style lang="scss" scoped>
    #header-logo { width: 215px; }

    @media only screen and (min-width: 1200px){
        .header-logo-wrapper { padding: 7px; }
        #header-logo { width: 300px;}
    }
</style>
